import React from "react"

const Pagi2 = ({
  gotoPage,
  previousPage,
  canPreviousPage,
  nextPage,
  canNextPage,
  pageIndex,
  pageOptions,
}) => {
  let limitedPageOptions = pageOptions

  // If there are more than 30 pages, limit the displayed pages to 5
  if (pageOptions.length > 6) {
    const startIndex = Math.max(0, pageIndex - 2)
    const endIndex = Math.min(startIndex + 5, pageOptions.length)
    limitedPageOptions = pageOptions.slice(startIndex, endIndex)
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <p>
          Showing {pageIndex * 10 + 1} to{" "}
          {Math.min((pageIndex + 1) * 10, pageOptions.length * 10)} of{" "}
          {pageOptions.length * 10} entries
        </p>

        <nav aria-label="...">
          <ul className="pagination">
            <li
              className={`page-item ${canPreviousPage ? "" : "disabled"} `}
              onClick={previousPage}
            >
              <a className="page-link">Previous</a>
            </li>

            {limitedPageOptions.map(page => (
              <li
                key={page}
                onClick={() => gotoPage(page)}
                className={`page-item`}
              >
                <a
                  className={`page-link ${
                    page === pageIndex ? "bg-purple" : ""
                  } `}
                >
                  {page + 1}
                </a>
              </li>
            ))}

            <li
              className={`page-item ${canNextPage ? "" : "disabled"} `}
              onClick={nextPage}
            >
              <a className="page-link">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  )
}

export default Pagi2
